<template>
    <kt-panel>
        <div class="accordion accordion-toggle-arrow" id="userFilter">
            <div class="card" style="overflow:inherit">
                <div class="card-header bg-transparent" id="headingOne">
                    <div class="card-title collapsed" data-toggle="collapse"
                         data-target="#filterForm"
                         aria-controls="filterForm">
                        {{ $t('label.search') }}
                    </div>
                </div>
                <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#userFilter">
                    <div class="card-body">
                        <form @submit.prevent="action($event, query)">
                            <kt-form-section>
                                <kt-form-row>
                                    <kt-col xs="12" sm="6" md="6">
                                        <kt-form-group>
                                            <kt-form-label for="title">
                                                {{ $t('label.title') }}
                                            </kt-form-label>
                                            <kt-form-control ref="title" name="title" id="title" v-model="query.title"></kt-form-control>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="6">
                                        <kt-form-group>
                                            <kt-form-label for="created_at">
                                                {{ $t('label.created_at') }}
                                            </kt-form-label>
                                            <button id="created_at"
                                                    @click="clearCreatedAt"
                                                    class=" btn btn-label-danger trash-btn"
                                            >
                                                <i class="la la-trash-o"></i>
                                            </button>
                                            <datePicker
                                                format="YYYY-MM-DD HH:mm:ss"
                                                display-format="dddd jDD jMMMM jYYYY"
                                                input-class="form-control"
                                                v-model="query.created_at" type="date" />
                                        </kt-form-group>
                                    </kt-col>
                                </kt-form-row>
                            </kt-form-section>

                            <kt-form-section>
                                <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                            </kt-form-section>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </kt-panel>
</template>

<script>

import { mapGetters } from 'vuex';

export default {
    props: {
        action: {
            default: function(e, query) {},
            required: true,
        }
    },
    data: function() {
        return {
            categories: [],
            query: {},
        }
    },
    computed: {
        ...mapGetters('ticket', [
            'status'
        ])
    },
    mounted() {
    },
    methods: {
        clearCreatedAt() {
            if(this.query.created_at) {
                this.query.created_at = null
            }
        },
    }
}
</script>

<style>

</style>